import { render, staticRenderFns } from "./TPDP.vue?vue&type=template&id=75193ce2"
import script from "./TPDP.vue?vue&type=script&lang=js"
export * from "./TPDP.vue?vue&type=script&lang=js"
import style0 from "./TPDP.vue?vue&type=style&index=0&id=75193ce2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports